import { DOCUMENT_TYPE, HeadCell } from 'models';

export const headCells: readonly HeadCell<DOCUMENT_TYPE>[] = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'ID',
  },
  {
    id: 'Parent',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Parent Name',
  },
  {
    id: 's3_url',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Document',
  },

  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Created At',
  },
];
